export var CMSPageType;
(function (CMSPageType) {
    CMSPageType["NotFound"] = "404";
})(CMSPageType || (CMSPageType = {}));
var CDN_BASE_URL = 'https://cdn1.home24.net';
var removeBackSlashes = function (imageName) { return imageName.replace('/', ''); };
export var getImageURLForCDN = function (service, height, width, imageName, format) {
    if (format === void 0) { format = 'png'; }
    var dimension = height + "x" + width;
    var formattedImageName = removeBackSlashes(imageName);
    return CDN_BASE_URL + "/images/media/catalog/" + service + "/" + dimension + "/" + format + "/" + formattedImageName;
};
export var transformOriginalImageUrl = function (_a) {
    var url = _a.url, width = _a.width, height = _a.height;
    return url.replace('/original/', "/" + width + "x" + height + "/");
};
export var transformPrismicImageUrl = function (url, width) {
    var imageURL = new URL(url);
    imageURL.searchParams.set('width', width.toString());
    return imageURL.toString();
};
var getAllPixelRatioImgSizes = function (url, size) { return ({
    x1: transformOriginalImageUrl({ url: url, width: size, height: size }),
    x2: transformOriginalImageUrl({ url: url, width: 2 * size, height: 2 * size }),
    x3: transformOriginalImageUrl({ url: url, width: 3 * size, height: 3 * size }),
}); };
export var urlToLazyImageProps = function (url, _a) {
    var _b = _a.thumbnail, thumbnail = _b === void 0 ? 16 : _b, mobile = _a.mobile, tablet = _a.tablet, desktop = _a.desktop, large_desktop = _a.large_desktop;
    return ({
        thumbnail: transformOriginalImageUrl({
            url: url,
            width: thumbnail,
            height: thumbnail,
        }),
        mobile: getAllPixelRatioImgSizes(url, mobile),
        tablet: getAllPixelRatioImgSizes(url, tablet),
        desktop: getAllPixelRatioImgSizes(url, desktop),
        large_desktop: getAllPixelRatioImgSizes(url, large_desktop),
    });
};
export var getCMSPageImageUrl = function (page, filename) {
    return CDN_BASE_URL + "/static/media/om/img/cms/page/" + page + "/" + filename;
};
